import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { StrainMeasurementImage } from "@app/strain/common/models/view-measurement-models/strain-measurement.image";
import { Gage } from "@app/strain/config/gages/models/gage.model";
import {
    StrainGageConfigurationFormComponent
} from "@app/strain/common/components/measurement-forms/strain-gage-configuration-form/strain-gage-configuration-form.component";

@Component({
    selector: 'app-strain-gage-configuration-modal',
    templateUrl: './strain-gage-configuration-modal.component.html',
    styleUrls: ['./strain-gage-configuration-modal.component.scss']
})
export class StrainGageConfigurationModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: false}) modal: ModalComponent;
    @ViewChild(StrainGageConfigurationFormComponent, {static: false}) gageConfigurationForm: StrainGageConfigurationFormComponent;

    @Input() isLoading = true;
    @Input() showValidations = false;
    @Input() gages: Gage[] = [];

    @Output() closeModal = new EventEmitter();
    @Output() save = new EventEmitter();

    measurementImages: StrainMeasurementImage;
    isOpen = false;
    constructor() {}

    ngOnInit() {
    }

    open(measurementImage: StrainMeasurementImage = null) {
        this.measurementImages = measurementImage;
        this.showValidations = false;
        this.isOpen = true;
        this.modal.open();
    }

    close() {
        this.isOpen = false;
        this.modal.close();
    }

    onSave() {
        if (this.gageConfigurationForm?.valid()) {
            this.showValidations = false;
            this.save.emit(this.gageConfigurationForm.value());
            this.gageConfigurationForm.reset();
            this.close();
        } else {
            this.showValidations = true;
        }
    }
}
